import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { type ReactNode } from 'react';

import { ErrorBoundary } from './error-boundary';

interface Props {
  children: ReactNode;
}

/**
 * Combines React error boundary with TanStack Query's error reset.
 * When the user clicks "Try Again", both the error boundary and
 * any failed queries are reset so they refetch automatically.
 */
export function QueryErrorBoundary({ children }: Props) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary onReset={reset}>
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
